import React from "react";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCards } from "./ProjectCards";
import colorSharp2 from "../assets/img/color-sharp2.png";
import daniel from "../assets/img/daniel.jpg";
// import john from "../assets/img/john.jpg";
// import saul from "../assets/img/saul.jpg";
import sdkmonitor from "../assets/img/sdkmonitor.png";
import heras from "../assets/img/heras.jpg";
import ubytec from "../assets/img/ubytec.jpg";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Projects = () => {
  const projects = [
    {
      title: "Aruba - SDKMonitor",
      description: "Monitor a switch's hardware and mac list",
      imgUrl: sdkmonitor,
      githubUrl: 'https://github.com/eldanielh31/sdkmonitor'
    },
    {
      title: "HERAS - E-commerce",
      description: "Shop e-commerce with admin dashboard and database",
      imgUrl: heras,
      githubUrl: 'https://github.com/eldanielh31/ShopHERAS'
    },
    {
      title: "TEC - UbyTEC",
      description: "Online food shopping site from different restaurants",
      imgUrl: ubytec,
      githubUrl: 'https://github.com/eldanielh31/UbyTec'
    }
  ];
  const team = [
    {
      title: "Daniel Brenes Gómez",
      description: "Designer & Developer",
      imgUrl: daniel,
      githubUrl: 'https://github.com/eldanielh31'
    },
    // {
    //   title: "John Navarro Ramírez",
    //   description: "Front End Developer",
    //   imgUrl: john,
    //   githubUrl: 'https://github.com/Jonnas098'
    // },
    // {
    //   title: "Saul Gómez Ramirez",
    //   description: "Designer & Developer",
    //   imgUrl: saul,
    //   githubUrl: 'https://github.com/SAG0RA'
    // }
  ];

  return (
    <section className="project" id="project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility offset={500}>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Projects</h2>
                  <p>
                    On our GitHub page, we have a large number of public repositories that showcase our work on different technologies and projects. 
                    By showcasing our projects online, we ensure that our customers and collaborators can see and evaluate our work in real time,
                     demonstrating our expertise and commitment to excellence in software development.
                  </p>
                </div>
              )}
            </TrackVisibility>
            <Tab.Container id="projects-tabs" defaultActiveKey="first">
              <Nav
                variant="pills"
                className="nav-pills mb-5 justify-content-center alig-items-center"
                id="pills-tab"
              >
                <Nav.Item>
                  <Nav.Link eventKey="first">Projects</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second">Our Team</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="third">About Us</Nav.Link>
                </Nav.Item>
              </Nav>
              <TrackVisibility offset={1000} partialVisibility>
                {({ isVisible }) => (
                  <Tab.Content
                    id="slideInUp"
                    className={
                      isVisible ? "animate__animated animate__slideInUp" : ""
                    }
                  >
                    <Tab.Pane eventKey="first">
                      <Row>
                        {projects.map((project, index) => {
                          return <ProjectCards key={index} {...project} />;
                        })}
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                      <Row>
                        {team.map((member, index) => {return <ProjectCards key={index} {...member}/>})}
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      {" "}
                      <p>
                        At Buyoi, we are a team of developers passionate about creating innovative and customized solutions for our clients. With several years of experience in web and mobile development, we are committed to providing high quality technology solutions that meet the needs of our clients.
                        <br></br>
                        We believe in the importance of communication and collaboration with our clients to understand their needs and goals. We work closely with our clients to ensure that their solutions meet their unique requirements and achieve the desired results.
                        <br></br>
                        At Buyoi, we are passionate about technology and strive to be at the forefront of the latest development trends. We make sure to stay up-to-date on the latest tools and technologies to ensure that our clients get innovative and effective solutions.
                        <br></br>
                        We believe that our clients' success is our success. We take pride in our work and ensure that we provide high quality solutions that exceed our clients' expectations. We are committed to providing excellent customer service and working with our clients to ensure the satisfaction and success of their projects.
                        <br></br>
                        In short, at Buyoi, we believe in excellence in software development and are committed to providing high quality, customized technology solutions that meet our clients' needs. We take pride in our work and we are committed to providing excellent customer service and working closely with our clients to ensure the success of their projects.
                      </p>
                    </Tab.Pane>
                  </Tab.Content>
                )}
              </TrackVisibility>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
      <img src={colorSharp2} alt="Image" className="background-img-right" />
    </section>
  );
};
